import { DIFF_LINE_PREFIX } from "../constants";
import type { RunCodeChangesToken, RunCodeChangesTokenizedDiffLine } from "../types";
import styles from "./styles.module.css";

const TOKEN_CLASS: Partial<Record<RunCodeChangesToken["type"], string>> = {
  string: styles.tokenString,
  number: styles.tokenNumber,
  boolean: styles.tokenBoolean,
  null: styles.tokenNull,
};

type RunCodeChangesStructuredDiffLineProps = {
  line: RunCodeChangesTokenizedDiffLine;
};

const RunCodeChangesStructuredDiffLine = ({ line }: RunCodeChangesStructuredDiffLineProps) => (
  <span className={styles[line.type]}>
    <span className={styles.linePrefix}>{DIFF_LINE_PREFIX[line.type]}</span>
    {line.tokens.map((token, i) => {
      const className = TOKEN_CLASS[token.type];

      if (className) {
        return (
          <span key={i} className={className}>
            {token.text}
          </span>
        );
      }

      return token.text;
    })}
    {"\n"}
  </span>
);

export default RunCodeChangesStructuredDiffLine;
